import { ToastProvider as NewToastProvider, useToast as useNewToast, ToastKind } from "../ui";

export const ToastProvider = NewToastProvider;

export type ToastSeverity = "success" | "info" | "warning" | "error";

export interface ToastOptions {
  message: string;
  severity?: ToastSeverity;
  duration?: number;
  id?: string | number;
}

const sevToKind: Record<ToastSeverity, ToastKind> = {
  success: "success",
  info: "info",
  warning: "warn",
  error: "danger",
};

let bridgeIdCounter = 1;

export const useToast = () => {
  const { show } = useNewToast();
  return {
    showToast: (opts: ToastOptions): string | number => {
      const kind = sevToKind[opts.severity ?? "info"] ?? "info";
      show(kind, opts.message);
      return opts.id ?? `toast_${Date.now()}_${bridgeIdCounter++}`;
    },
    hideToast: (_id: string | number) => {
      // No-op: the new Toast auto-dismisses after 4s and is click-to-dismiss.
    },
    clearToasts: () => {
      // No-op for the same reason.
    },
  };
};
